export default __webpack_public_path__ + "static/media/Google__G__Logo.330a2dc7.svg";